// platform always makes a keyring purchase for the signed in user, so there is none to make for another user here
export default {
  dialogs: {
  },
  routes: {},
  components: {},
  resources: {},
};
